import { render, staticRenderFns } from "./FooterForUpdate.vue?vue&type=template&id=2bd3e680&scoped=true&"
import script from "./FooterForUpdate.vue?vue&type=script&lang=js&"
export * from "./FooterForUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FooterForUpdate.vue?vue&type=style&index=0&id=2bd3e680&prod&lang=scss&scoped=true&"
import style1 from "./FooterForUpdate.vue?vue&type=style&index=1&id=2bd3e680&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3e680",
  null
  
)

export default component.exports